import createLucideIcon from '../createLucideIcon';

const ShieldClose = createLucideIcon('ShieldCloseIcon', [
  ['path', { d: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z', key: '3xmgem' }],
  ['line', { x1: '9.5', y1: '9', x2: '14.5', y2: '14', key: '154127' }],
  ['line', { x1: '14.5', y1: '9', x2: '9.5', y2: '14', key: '1rm6h8' }],
]);

export default ShieldClose;
